import { useQuery } from "@tanstack/react-query";
import { route } from "../../../../../../shim/jsbridge";
import { queryOptions } from "../../../../../search/hooks";
import { Analysis } from "../../../../@types";
import api from "../../../../api";
import { sampleReportKeys } from "../../../../queryKeys";

const getDynamicAnalysisData = <T>(endpoint: string) =>
  api.getDynamicAnalysisData<T>(endpoint).then(({ data: details }) => details);

const useGetProcessDetails = <T>(
  hash: string | undefined,
  analysis: Analysis,
  processId?: number,
  parentProcessId?: number,
  uploadId?: string
) => {
  const endpoint = hash
    ? route(`api_${analysis}_behavior_processes`, [
        hash,
        parentProcessId,
        processId
      ])
    : route(`api_${analysis}_url_behavior_processes`, [
        uploadId,
        parentProcessId,
        processId
      ]);

  const { isLoading, data } = useQuery({
    ...queryOptions,
    queryKey: sampleReportKeys.processDetails(endpoint),
    queryFn: () => getDynamicAnalysisData<T>(endpoint),
    enabled: Boolean(processId && parentProcessId)
  });

  return { isLoading, data };
};

export default useGetProcessDetails;
